import React from 'react'
import {
  Wrapper, SvgStepIcon1, SvgStepIcon2, SvgStepIcon3,
} from './style'

type StepInputProps = {
  stepNumber:number
  stepfill:string
}
const StepIcon = ({ stepNumber, stepfill }:StepInputProps) => {
  switch (stepNumber) {
    case 1:
      return (
        <Wrapper>
          <SvgStepIcon1 stepfill={stepfill} />
          Teste
        </Wrapper>
      )
    case 2:
      return (
        <Wrapper>
          <SvgStepIcon2 stepfill={stepfill} />
          Dados
        </Wrapper>
      )
    case 3:
      return (
        <Wrapper>
          <SvgStepIcon3 stepfill={stepfill} />
          Resultado
        </Wrapper>
      )
    default:
      return (null)
  }
}
export default StepIcon
